define('ch_ga',[
    'jquery',
    'ch_selectors',
    'optional!google_analytics',
    'ch_cookie',
], function ($) {
    var ga = window.ga = (window.ga || function () {}); // TODO: should just export / import

    // when logging is enabled we wrap the ga() function and log its usage to the console
    if (CH && CH.isGALoggingEnabled) {
        var originalGa = ga;
        window.ga = ga = function() {
            var args = Array.prototype.slice.call(arguments, 0);
            console.log('ga() called with:', args);
            return originalGa.apply(this, args);
        }
    }

    CH.GA = CH.GA || {};

    var siteProps = {
        cookieDomain: CH.GA.cookieDomain,
        siteSpeedSampleRate: 50
    };

    if (CH.getCookie('ch_i')) {
        siteProps.userId = CH.getCookie('ch_i').replace(/"(\w+)"\|.+/, "$1");
    }

    ga('create', CH.GA.ua, siteProps);
    ga('set', 'page', CH.GA.page);

    if (CH.GA.optimize && CH.GA.optimizeId) {
        ga('require', CH.GA.optimizeId);
    }

    if (CH.GA.remarketing) {
        ga('require', 'displayfeatures');

        if (
            CH.dynamicRetargeting &&
            CH.dynamicRetargeting.dynx_itemid &&
            CH.dynamicRetargeting.dynx_pagetype
        ) {
            ga('set','dimension5', CH.dynamicRetargeting.dynx_itemid);
            ga('set','dimension12', CH.dynamicRetargeting.dynx_pagetype );
            ga('set','dimension18', CH.dynamicRetargeting.dynx_totalvalue);
        }
    }

    // These campaign and referrer values are optionally set by widget code if we want to force these
    // values for all Timeout widgets regardless of where they're showing up, for example.
    if (CH.GA.campaignName) {
        ga('set', 'campaignName', CH.GA.campaignName);
    }

    if (CH.GA.campaignSource) {
        ga('set', 'campaignSource', CH.GA.campaignSource);
    }

    if (CH.GA.campaignMedium) {
        ga('set', 'campaignMedium', CH.GA.campaignMedium);
    }

    if (CH.GA.campaignContent) {
        ga('set', 'campaignContent', CH.GA.campaignContent);
    }

    if (CH.GA.referrer) {
        ga('set', 'referrer', CH.GA.referrer);
    }

    // We want these dimensions to stick to all hits on this page (including events)
    if (CH.GA.dimensions) {
        // User - Current Referral Partner
        ga('set', 'dimension19', CH.GA.dimensions.dimension19);
        // User - City
        ga('set', 'dimension15', CH.GA.dimensions.dimension15);
    }

    if (CH.GA.userIntentData) {
        ga(
            'send',
            'event',
            'User Intent',
            'User Intent data',
            CH.GA.userIntentData,
            { nonInteraction: true, }
        );
    }

    ga('send', 'pageview', CH.GA.dimensions);

    CH.GA.tests = CH.GA.tests || [];
    CH.GA.tests.forEach(function(test) {
        ga('send', 'event', 'A/B Test', test.name, test.name + ' - ' + test.variant, {
            nonInteraction: true,
        });
    });

    $(function () {
        $._('gift-card-subnav').on('click', function () {
            ga('send', 'event', 'Gift Card Ads', 'Subcategory Clicked', null, {
                nonInteraction: false,
            });
        });

        $._('gift-card-filter-banner').on('click', function () {
            ga('send', 'event', 'Gift Card Ads', 'Filter Banner Clicked', null, {
                nonInteraction: false,
            });
        });

        $('.js-track-click-children > *').on('click', function(e) {
            var me = this;
            var parent = $(me).parent();
            var eventCategory = $(parent).data('event-category');
            var eventAction = $(parent).data('event-action');
            if (eventCategory && eventAction) {
                ga(
                    'send',
                    'event',
                    eventCategory,
                    eventAction,
                    $(me).index() + 1,
                    { nonInteraction: false }
                );
            }
        });

        $('.js-track-click').on('click', function(e) {
            var me = this;
            var eventCategory = $(me).data('event-category');
            var eventAction = $(me).data('event-action');
            if (eventCategory && eventAction) {
                ga(
                    'send',
                    'event',
                    eventCategory,
                    eventAction,
                    $(me).data('event-label'),
                    { nonInteraction: false }
                );
            }
        });

        if (CH.isFirstPageviewInSession && CH.Hub.id && CH.geo_hub) {
            ga(
                'send',
                'event',
                'Landing Page Hub Tracking',
                'Landed on page in hub: ' + CH.Hub.uri,
                window.location.pathname,
                { nonInteraction: true }
            );

            ga(
                'send',
                'event',
                'Landing Page Hub Tracking',
                'Geo IP hub: ' + CH.geo_hub,
                window.location.pathname,
                { nonInteraction: true }
            );
        }
    });
    return ga; // we should be exporting ga and using that rather than doing that window. stuff
});

